import CalculatorPage from '@/components/Calculator/CalculatorPage';

import router from './index';

router.addRoute({
  path: '/{:crypto}-calculator',
  name: 'calculatorPage',
  component: CalculatorPage,
});

export default router;
